var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4956",
    "data-name": "Grupo 4956",
    transform: "translate(-10235 -4949)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_146",
    "data-name": "Elipse 146",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(10235 4949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M12.281,8.221a6.3,6.3,0,1,0,6.3,6.3A6.287,6.287,0,0,0,12.281,8.221Zm0,10.391a4.094,4.094,0,1,1,4.094-4.094,4.1,4.1,0,0,1-4.094,4.094ZM20.3,7.964a1.469,1.469,0,1,1-1.469-1.469A1.465,1.465,0,0,1,20.3,7.964Zm4.171,1.491a7.269,7.269,0,0,0-1.984-5.146,7.316,7.316,0,0,0-5.146-1.984c-2.028-.115-8.106-.115-10.134,0A7.306,7.306,0,0,0,2.065,4.3,7.293,7.293,0,0,0,.081,9.449c-.115,2.028-.115,8.106,0,10.134a7.269,7.269,0,0,0,1.984,5.146,7.326,7.326,0,0,0,5.146,1.984c2.028.115,8.106.115,10.134,0a7.269,7.269,0,0,0,5.146-1.984,7.316,7.316,0,0,0,1.984-5.146c.115-2.028.115-8.1,0-10.128Zm-2.62,12.3a4.145,4.145,0,0,1-2.335,2.335c-1.617.641-5.453.493-7.24.493s-5.629.142-7.24-.493a4.145,4.145,0,0,1-2.335-2.335c-.641-1.617-.493-5.453-.493-7.24s-.142-5.629.493-7.24A4.145,4.145,0,0,1,5.041,4.944c1.617-.641,5.453-.493,7.24-.493s5.629-.142,7.24.493a4.145,4.145,0,0,1,2.335,2.335c.641,1.617.493,5.453.493,7.24S22.5,20.147,21.855,21.758Z",
    transform: "translate(10248.005 4959.762)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgCircle);
export default __webpack_public_path__ + "static/media/IG-circle.7f8cfd44e08b3153a80c645ffbaa0a00.svg";
export { ForwardRef as ReactComponent };